import { call, put, all, takeEvery } from 'redux-saga/effects'

import { createAudienceService, deleteAudienceService, getAudiencesService } from '../services/audiences'
import {
  GET_AUDIENCES,
  getAudiencesFailure,
  getAudiencesSuccess,
  CREATE_AUDIENCE,
  createAudienceFailure,
  createAudienceSuccess,
  DELETE_AUDIENCE,
  deleteAudienceFailure,
  deleteAudienceSuccess,
  CREATE_AUDIENCE_BY_SUGGESTION,
  createAudienceBySuggestionSuccess,
  createAudienceBySuggestionFailure
} from '../actions/audiences'

function* audiencesWatcher() {
  yield all([
    // PLOP_APPEND_PATTERN_ANCHOR_WATCHER
    takeEvery(GET_AUDIENCES, getAudiencesWorker),
    takeEvery(CREATE_AUDIENCE, createAudienceWorker),
    takeEvery(CREATE_AUDIENCE_BY_SUGGESTION, createAudienceBySuggestionWorker),
    takeEvery(DELETE_AUDIENCE, deleteAudienceWorker)
  ])
}

// PLOP_APPEND_PATTERN_ANCHOR_WORKER

function* getAudiencesWorker({ params, platform }) {
  try {
    const response = yield call(getAudiencesService, params, platform)
    yield put(
      // BE may send pagination response even if the payload wasn't asking for it, here is handling it:
      getAudiencesSuccess(response, {
        isPaginationLoad: !!response.paging
      })
    )
  } catch (e) {
    yield put(getAudiencesFailure(e))
  }
}

function* createAudienceWorker({ params, platform }) {
  try {
    const response = yield call(createAudienceService, params, platform)
    yield put(createAudienceSuccess(response))
  } catch (e) {
    yield put(createAudienceFailure(e))
  }
}

function* createAudienceBySuggestionWorker({ params }) {
  try {
    const response = yield call(createAudienceService, params)
    yield put(createAudienceBySuggestionSuccess(response))
  } catch (e) {
    yield put(createAudienceBySuggestionFailure(e))
  }
}

function* deleteAudienceWorker({ params, platform }) {
  try {
    yield call(deleteAudienceService, params, platform)
    yield put(deleteAudienceSuccess(params.id))
  } catch (e) {
    yield put(deleteAudienceFailure(e))
  }
}

export default audiencesWatcher
